
    import { defineComponent } from 'vue';
    import axios from 'axios';

    import UiInput from '@/components/input/Input.vue';
    import UiButton from '@/components/button/Button.vue';

    export default defineComponent({
        name: 'ForgetPasswordFormPage',
        components: { UiInput, UiButton },
        emits: {
            back () {
                return true;
            },
            success () {
                return true;
            }
        },
        data () {
            return {
                loading: false,
                username: ''
            };
        },
        mounted () {
            document.getElementById('username')?.focus();
        },
        methods: {
            doRequest () {
                this.loading = true;
                axios.request({
                    url: '/api/v1/identity/password-reset',
                    method: 'post',
                    validateStatus: () => true,
                    params: {
                        identity_id: this.username
                    }
                })
                    .then(response => {
                        if (response.status === 404) {
                            throw new Error('User not found');
                        } else if (response.status !== 204) {
                            throw new Error('Unable to request password reset: ' + response.status + ' ' + response.statusText);
                        } else {
                            this.$emit('success');
                        }
                    })
                    .catch(error => {
                        // eslint-disable-next-line no-console
                        console.log(error);
                        alert(String(error));
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        }
    });
